import $, { extend } from 'jquery';
import React,{useEffect,useContext,useState} from 'react';
// import {GbSetGetPartyInfo,GbSetGetItemInfo,
//   GbSetSiteMaster,GbSetVehicleMaster} from '../cGlobal/cls_global';
import { GlobalContext } from '../context';
import {CallMapMethod_CBack,getAppUrl} from '../function_lib/common_lib';
import Select from 'react-select';
import axios from 'axios';

export function Comp_Auto_MachineUsers_New(props){
    const {gbStMachineUsers, setMachineUsers} =useContext(GlobalContext);
    const [selectedOption, setSelectedOption] = useState(null);
    const handleChange = (option) => {
      setSelectedOption(option);
      if(typeof props.onChangeBack!=="undefined"){
        props.onChangeBack(option);
      }
      //alert(JSON.stringify(option));
      //onChange(option);
    };
  
    useEffect(() => {
        
      // This code will run after the component has mounted
  //alert("hello"+gbStPartyInfo+"noon");   
  const fetchData = async () => {
    //alert(props.setData);
  if((gbStMachineUsers===0 || gbStMachineUsers===null)){
  
const map = new FormData();
map.append("curl_type", "getMachineUsers");
map.append("res_func", "callBackrrr");
map.append("gb_token", props.userObject[0].app_user_id);

  const apiUrl = getAppUrl()+"getMachineUsers";
  //alert(apiUrl);
  const response = await axios.post(apiUrl, map);
  //alert(response.data);
  var checkData=$($($.parseHTML(response.data)).filter("#resP")).text();
  var checkMsg=$($($.parseHTML(response.data)).filter("#resPS")).text();
  if(checkData!=="0"){
    let compMasterData=JSON.parse(checkData);
    //ExtCompAutoComplete(props,compMasterData["party_info"]);
    setMachineUsers(compMasterData);
  }
  }else{
  //ExtCompAutoComplete(props,gbStPartyInfo);
  }
  
  
  }


  if(gbStMachineUsers?.length>0){
   
  
    if(typeof props.propSelected!=="undefined"){
      //alert("i m in selected iption");
      //alert(props.propSelected)
      //const listFltrTmp=d=>===props.topId;
     // alert(JSON.stringify(gbStMachineUsers));
if(props.propSelected!==""){
  let tmpSelected=gbStMachineUsers.filter(opt=>opt.id.toString()===atob(props.propSelected).toString())
  //alert(JSON.stringify(tmpSelected[0]));
  if(tmpSelected.length===1){
    setSelectedOption(tmpSelected[0]);
    if(typeof props.onChangeBack!=="undefined"){
      props.onChangeBack(tmpSelected[0]);
    }
  }
}
    
      
    } 
  }
      
      fetchData();
      
      
      // You can return a cleanup function if needed
      return () => {
        // This code will run when the component unmounts
        //console.log('Component unmounted');
      };
    }, [gbStMachineUsers,props.propSelected]); // Pass an empty array as the second argument to run the effect only once after mounting
  if (props.setData!==true){
    return(<><Select 
      //inputId={props.target_obj}
       id={props.comp_id}
       name={props.comp_name}
      target_obj={props.target_obj}
      value={selectedOption}
      onChange={handleChange}
      options={gbStMachineUsers}
      getOptionLabel={(option) => option.business_name+" / "+option.dealer_code}
      getOptionValue={(option) => btoa(option.id)}
      placeholder={props.placeHolder}
      isClearable
    />
    <input className={props.propClass} type="hidden" name={props.target_obj} id={props.target_obj} 
    value={selectedOption ? btoa(selectedOption.value) : ''}
    />
    {typeof  props.comp_sel_text!=="undefined"?<input className={props.propClass} type="hidden" name={props.comp_sel_text} id={props.comp_sel_text}
  value={selectedOption?selectedOption.label:''}
   />:''}
    </>)
  }else{
    return(<></>)
  }
  
  }
  export default Comp_Auto_MachineUsers_New;